import api from "src/api/axios";

const createCountry = async (input) => {
  return api.post(`/country`, input).then((result) => {
    return result.data;
  });
};

const createBulkCountry = async (input) => {
  return api.post(`/country/bulk-create`, input).then((result) => {
    return result.data;
  });
};

const updateCountry = async (input, id) => {
  return api.patch(`/country/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/country/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getCountryList = async ({ limit, page }) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
  });
  return api.get(`/country?${params}`).then((result) => {
    return result.data;
  });
};

const getActiveCountryList = async ({ limit, page, status }) => {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (status) params.append("isActive", status);
  return api.get(`/country?${params}`).then((result) => {
    return result.data;
  });
};

const getSingleCountry = async (id) => {
  return api.get(`/country/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createCountry,
  getCountryList,
  getSingleCountry,
  updateCountry,
  updateActiveStatus,
  createBulkCountry,
  getActiveCountryList,
};
